import { SceneManager, ViewableLayer } from "scene-manager";
import { Game } from "../Game";
import { BlockCutCleanerContext } from "./composition/BlockCutCleanerContext";
import { PreloaderScene } from "./scenes/preloader/PreloaderScene";
import { CanvasScaler } from "../canvas/CanvasScaler";
import { BlockCutCleanerViewableLayer } from "./layers/BlockCutCleanerViewableLayer";
import { SceneManagerWrapper } from "./SceneManagerWrapper";
import { FederatedEvent } from "@pixi/events";

export class BlockCutCleaner extends Game {
    private readonly context: BlockCutCleanerContext;
    private readonly sceneManager: SceneManager;
    private readonly canvasScaler: CanvasScaler;

    public constructor() {
        super();
        this.fixMemoryLeakInTrackingData();
        this.canvasScaler = new CanvasScaler(this.renderer, 1080, 1920);
        this.sceneManager = new SceneManagerWrapper(this.stage, {
            viewableLayerType: new BlockCutCleanerViewableLayer(this.canvasScaler),
            backgroundLayer: new ViewableLayer()
        });
        this.context = new BlockCutCleanerContext();
    }

    public override async launch(manifestPath: string): Promise<void> {
        await super.launch(manifestPath);
        this.context.build(this.canvasScaler, this.sceneManager);
        this.sceneManager.showViewableAsync(await this.context.resolve(PreloaderScene));
    }

    private fixMemoryLeakInTrackingData(): void {
        // Tree shaking hack
        console.log(FederatedEvent.name);
        const rootBoundary = this.renderer.events.rootBoundary;
        const customEventMapping = (function (e: FederatedEvent): void {
            const pointerId = (e as any)["pointerId"];
            if (this.mappingState.trackingData[pointerId]) {
                delete this.mappingState.trackingData[pointerId];
            }
        }).bind(rootBoundary);

        rootBoundary.addEventMapping("pointerleave", customEventMapping);
        rootBoundary.addEventMapping("pointerout", customEventMapping);
    }
}